import { render, staticRenderFns } from "./Usuario.vue?vue&type=template&id=1229d356&scoped=true&lang=pug"
import script from "./Usuario.vue?vue&type=script&lang=js"
export * from "./Usuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229d356",
  null
  
)

export default component.exports